import LeakedCredsChangePassword from './LeakedCredsChangePassword'
export default LeakedCredsChangePassword
